import React, {useState, useContext} from 'react';
import {AccountContext} from '../context/Accounts';
//import { useHistory } from 'react-router-dom';

export default (props) => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const {authenticate} = useContext(AccountContext);

//  let history = useHistory();

  const onSubmit = event => {
    event.preventDefault();

    let r_value = authenticate(email, password)
      .then(data => {
        console.log('Logged in!', data);
        window.location.reload(false);
      })
      .catch(err => {
        console.error('Failed to login!', err);
        alert("Incorrect password or username");
      });
    console.log('Promise me that', r_value);
  };

  const gotoModel = () => {
    console.log("in gotoModel!");
    //onSubmit();
    //history.push('./Signup');
  }

  return (
    <div className="login">
      <h2>Login</h2>
      <form onSubmit={onSubmit}>
        <p>
          <input
            type="email"
            value={email}
            onChange={event => setEmail(event.target.value)}
          />
        </p>
        <p>
          <input
            type="password"
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
        </p>
        <p>
          <button name="commit" onClick={gotoModel} type='submit'>Login</button>
        </p>
      </form>
    </div>
  );
};
